import { authAxios } from '../utils/apiConfig';
import { logger } from '../utils/logger';

const landingAxios = authAxios;

/**
 * Public landing-page GMB search (no auth required).
 */
export async function searchProspectGmb(query, targetCount = 8) {
  const trimmed = (query || '').trim();
  if (!trimmed) {
    return { businesses: [] };
  }

  try {
    const response = await landingAxios.post('/feedback/landing/gmb-search', {
      query: trimmed,
      target_count: targetCount,
    });
    return response.data;
  } catch (error) {
    logger.error('Landing GMB search failed:', error);
    throw new Error('Could not search Google Business Profiles. Please try again.');
  }
}

/**
 * Resolve the best market keyword for a selected GMB profile.
 */
export async function resolveProspectMarketKeyword(
  anchor,
  { userKeyword = '', neighborhood = '', manualCity = '' } = {},
) {
  if (!anchor?.place_id && !anchor?.name) {
    throw new Error('Select a Google Business Profile first');
  }

  try {
    const response = await landingAxios.post('/feedback/landing/resolve-market-keyword', {
      anchor,
      max_validations: 20,
      user_keyword: (userKeyword || '').trim(),
      neighborhood: (neighborhood || '').trim().slice(0, 80),
      manual_city: (manualCity || '').trim().slice(0, 80),
    });
    return response.data;
  } catch (error) {
    logger.error('Landing market keyword resolve failed:', error);
    throw new Error('Could not find the best market search for this business.');
  }
}

/**
 * Fetch competitor preview for a resolved market keyword.
 */
export async function previewMarketCompetitors(keyword, targetCount = 20, location = '') {
  const trimmed = (keyword || '').trim();
  if (!trimmed) {
    return { competitors: [] };
  }

  try {
    const response = await landingAxios.post('/feedback/landing/preview-competitors', {
      keyword: trimmed,
      target_count: targetCount,
      location: (location || '').trim(),
    });
    return response.data;
  } catch (error) {
    logger.error('Landing competitor preview failed:', error);
    throw new Error('Could not load competitors for this market.');
  }
}
